import { ref, Ref } from "vue"
import { GallerySlide } from "features/posts/gallery/PostGalleryPreviewDesktop.vue"
import { Post } from "suus-api"

export const usePostGalleryCarousel = () => {
  const slides: Ref<GallerySlide[]> = ref([])
  const slideItemsCount = ref(0)

  const resizeSlides = (carouselElement: HTMLElement, post: Post) => {
    const carouselWidth = carouselElement.offsetWidth
    const thumbnailWidth = 128
    const padding = 8

    const fittingThumbnailsWithPadding = Math.floor(
      carouselWidth / (thumbnailWidth + padding)
    )
    const isOneMoreFitting =
      carouselWidth % (thumbnailWidth + padding) >= thumbnailWidth

    const thumbsPerSlide = isOneMoreFitting
      ? fittingThumbnailsWithPadding + 1
      : fittingThumbnailsWithPadding

    slideItemsCount.value = thumbsPerSlide

    const previewThumbnails = post.event_media_preview

    slides.value = []
    for (let i = 0; i < previewThumbnails.length; i += thumbsPerSlide) {
      slides.value.push(previewThumbnails.slice(i, i + thumbsPerSlide))
    }

    const lastSlide = slides.value[slides.value.length - 1]
    if (lastSlide.length < thumbsPerSlide) {
      const missingThumbnails = thumbsPerSlide - lastSlide.length
      for (let i = 0; i < missingThumbnails; i++) {
        if (i === 0) {
          lastSlide.push("more")
          continue
        }
        lastSlide.push("placeholder")
      }
    } else {
      lastSlide[lastSlide.length - 1] = "more"
    }
  }

  return {
    slides,
    resizeSlides,
    slideItemsCount,
  }
}
